export {
    default
} from './route.config';
const _import =  require('../_import_' + process.env.NODE_ENV)


export const Error401 = _import('Common/errorPage/401');
export const Error404 = _import('Common/errorPage/404');



// WEBPACK FOOTER //
// ./src/views/Common/index.js